import { render, staticRenderFns } from "./info-more.vue?vue&type=template&id=cc081aaa&scoped=true&"
import script from "./info-more.vue?vue&type=script&lang=js&"
export * from "./info-more.vue?vue&type=script&lang=js&"
import style0 from "./info-more.vue?vue&type=style&index=0&id=cc081aaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc081aaa",
  null
  
)

export default component.exports